import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/agent-hero-2.webp")